var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{staticClass:"mobile-message-page"},[_c('div',{staticClass:"message-container"},[_c('h4',[_vm._v(_vm._s(_vm.msg))]),_c('p',{staticClass:"close",on:{"click":_vm.handleClose}},[_vm._v("Confirm")])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }